import axios from "axios";

// export default axios.create({
//   baseURL: "http://localhost:5000/api/v1",
// });

export default axios.create(
  {
    baseURL: "https://recipe-recommender-system-backend.vercel.app/api/v1",
  },
  { withCredentials: true }
);
